export default {
  logout: "Logout",
  productName:'HiTeach Mind',
  markDownErr:'Markdown format error',
  markDownNote:'Please enter the correct Markdown format',
  defaultMind:{
    templateName:'Mind map Template',
    root:'Mind map Topic',
    node1:'Node 1',
    node2:'Node 2',
    node3:'Node 3',
    node4:'Node 4',
  },
  mainMenu: {
    gotoHome: "My Dashboard",
    rename: "Rename",
    inputMD: "Import document (.md)",
    pasteMD: "Paste markdown text",
    copyMD: "Copy text to Clipboard",
    downloadMD: "Download document (.md)",
    downloadImage: "Download mind map image",
    exportStaticMindmap: "Export static mind map",
    alreadyCopied: "Copied to Clipboard",
    coworkMode: "Cowork",
    backCollect: "Back to Collection",
  },
  downloadImageSuccess: "Image downloaded successfully",
  downloadImageFailed: "Failed to download image",
  generateImageFailed: "Failed to generate image",
  staticMindmap: {
    title: "Mind Map Topic",
    urlLabel: "Static Mind Map URL：",
    copied: "URL copied to clipboard",
    loadFailed: "Failed to load static mind map",
  },
  phoneticFont: {
    loading: "Loading phonetic font...",
    loadFailed: "Failed to load phonetic font",
  },
  anonymousNameBox: {
    placeholder: "Please enter a name (10 characters or less)",
    welcomeTitle: 'Welcome to HiTeach Cloud Mind Map',
    title: "Quick Use Without Login",
    or: 'or',
    save: "Use This Name",
    loginHint:"Login/Apply account to use"
  },
  renameBox: {
    title: "Rename",
    save: "Save Changes",
  },
  coworkMode: {
    edit: "Collaboration Mode",
    view: "Read-Only Mode",
  },
  mindmapTypeSelection: {
    title: "Please select HiTeach mind map type",
    localMindmap: "Create a local mind map",
    cloudMindmap: "Reference a cloud mind map",
  },
  unsupportFC: "Sharing website does not currently support this feature!",
  auth: {
    notLoggedInShareWarning: "You are not logged in and cannot perform sharing operations. Please log in first and try again."
  },
  initializeFluidRelay: "Initializing container... Please wait",
  cannotConnect: "Cannot connect to server. Please check network connection or try again later",
  tryingToGetContainer:'Trying to get data... Please wait',
  disconnected: "Detected a connection interruption or other errors. Please check the network and refresh the page before trying again",
  initializeOK: "Initialization Successful",
  initializeFailed: "Initialization Failed, please check the URL, if the URL is correct, please check if the owner has deleted the content",
  cannotMoveToChild: "Cannot move to your own child node",
  saveOK: "Save Successful",
  saveFailed: "Save Failed",
  alreadyDeleted: "Already Deleted",
  snapshoting: "Taking Screenshot ~",
  updateSnapshot: "Update Screenshot",
  relayout: "Reorganizing ~",
  tooManyUsers: "Currently too many users online, more than 100 people, may have communication delay, please try again later.",
  userLimitReached: "User Limit Reached",

  新增: "New Node",
  編輯: "Edit Node",
  輸入文字: "Type something...",
  確定: "OK",
  取消: "Cancel",
  請先選取節點: "Please select a node first!",
  不可刪除有子項目的節點: "Nodes with sub-projects cannot be deleted!",
  新增失敗: "The new failed, the parent node has been deleted!",
  編輯失敗: "Editor failed, the selected node has been deleted!",
  加入根節點: "Add Root Node",
  左邊: "Left",
  右邊: "Right",
  已是最上面: "Already on top!",
  已是最下面: "Already at the bottom!",
  圖片: "Image",
  圖片過大提示字1: "The selected image is too large (please keep it under",
  圖片過大提示字2: "MB). Please choose another one!",
  連結: "Link",
  連結網址: "Link URL",
  連結名稱: "Link Name",
  輸入URL: "Enter URL...",
  輸入連結名稱: "Enter link name...",
  註解: "Annotation",
  進階設定: "Advanced Settings",
  線條顏色: "Line Color",
  節點顏色: "Node Color",
  preEditHint: "Note: The previous editor of the current node is",
  confirmUpdate: ", are you sure you want to modify it?",
  moveNodeTitle: "Move Node",
  moveNodeHint: "Please select a parent node.",
  noTopic: "no topic",
  menu: {
    新增: "Add",
    刪除: "Delete",
    上移: "Move up",
    下移: "Move down",
    左移:'Move left',
    右移:'Move right',
    編輯: "Edit",
    複製: "Copy",
    檢視圖片: "View image",
    最後更新: "Last update",
    檢視節點變更記錄: "View node change log",
    lock: "Lock",
    unlock: "unlock",
    locked: "locked",
    move: "Move",
    applyColor: "Apply Color",
    applyColorSuccess: "Color applied to all child nodes",
    allRightLayout: "All Right Layout",
    allRightLayoutSuccess: "All first-level child nodes adjusted to right layout",
    allLeftLayout: "All Left Layout",
    allLeftLayoutSuccess: "All first-level child nodes adjusted to left layout",
    noChildrenToApply: "Root node has no child nodes to apply",
  },
  treeMenu: {
    currentMoveNode: "The node (including its child nodes) to be moved.",
    selectedParentNode: "Set as parent node",
  },
  imgEditor: {
    詢問離開動作: "Choose an Action",
    保存圖片: "Save Image",
    捨棄變更: "Discard Changes",
    取消: "Cancel",
  },
  mindCollectPage:{
    viewURL:"View link",
    viewEditKey: "View edit password",
    deleteMindMap:"Delete mind map",
    editKey: "Edit password:",
    url:"Link:",
    submitMindMap: "Submit a mind map",
    createRefer:"Edit mind map draft",
    useTemplate:"Use template",
    seatNum: "Seat No.",
    name:"Name",
    inputNum: "Enter a number",
    inputName: "Enter your name",
    topic:"Topic",
    newTopic: "New collection area",
    searchTopic: "Search name...",
    submitClose: "Collection has stopped!",
    viewClose: "It has been set to not allow clicks to view content!",
    templateTips: "Tips: After creation, you can click Edit Template to let users use it as a reference for submitting assignments",
   
    },
  mindmapHome: {
    login: "Login",
    logout: "Logout",
    logoutOK: "Logged out~",
    share: "Share Status",
    shareShort:'Share',
    delete: "Delete",
    rename: "Rename",
    detailInfo: "Detailed Information",
    copy: "Copy",
    renameFile: "Rename File",
    save: "Save Changes",
    haveLinkCanDo: "Anyone with the link can",
    closeShare: "Close Sharing",
    publishShare: "Publish Sharing",
    publishAsAssignmentTemplate: "Publish as Assignment Template",
    comfirmDelete: "Are you sure you want to delete this mind map?",
    mindmapCreator: "Creator",
    mindmapEditor: "Last Updated By",
    createTime: "Creation Time",
    updateTime: "Update Time",
    coworkMode: "Collaboration Mode",
    myMindMap: "My Mind Maps",
    search: "Search",
    add:'+ Add',
    addFile: "Mind Map",
    addCoworkMindMap:'Collaborative Mind Map',
    addMindCollect:'Mind Map Task',
    addCollectNormal:'General Folder',
    mindmapName: "Name",
    noData: "No Data Available",
    true: "Yes",
    false: "No",
    setCoworkInHTinfo: "When used in HT, forces Sharing files to be set to Collaboration Mode",
    initialize: "Initializing... Please wait",
    initializeFailed: "Initialization Failed",
    deleting: "Deleting... Please wait",
    deletingOKinFront: "Delete Successful",
    cannotConnect: "Cannot connect, please check your network",
    saveOk: "Save Successful",
    saveFailed: "Save Failed",
    confirmDelete:'Confirm deletion:',
    mindCollect:{
      share:'Setting',
      defaultName:'Assignment Task Name',
      createTitleSetting:'Create Task Folder',
      openSummitTitle:'Allow Task File Submissions',
      allowViewTitle:'Allow Viewing File Contents',
      colletSetting:'Task Folder Settings',
      updateSetting:'Task Folder Settings',
      confirmDeleteCollectText:'Are you sure you want to delete this task folder? After deletion, it cannot be recovered, and all files in the folder will also be deleted!',
      templateTips:'Tips: After creation, you can click "Edit Template" to let users use it as a reference for submitting assignments',
    },
    mindCollectNormal:{
      createTitleSetting:'Create General Folder',
      createMindMap:'Create Mind Map',
      defaultName:'Folder Name',
      colletSetting:'General Folder Settings',
      updateSetting:'General Folder Settings',
      confirmDeleteCollectText:'Are you sure you want to delete this folder? After deletion, it cannot be recovered, and all files in the folder will also be deleted!',
    },
    enterShortUrl:'No login required, please enter the short code for mind map or task folder',
    cannotOpenShortUrl:'ClipCode does not exist or has expired',
    coworkModeNoteText:{
      task:"Task",
      viewLongVer:'Read-only view',
      editLongVer:'Collaborative co-editing',
      view:'View',
      edit:'Edit',
      closeView:'Close View',
    },
    moveToFolder:'Move to Folder',
    moveOutFolder:'Move Out of Folder',
    noFolder:'No Data Available',
    moveSuccess:'Move Successful',
    moveFail:'Move Failed',
    moveOutSuccess:'Successfully Moved Out',
    moveOutFail:'Failed to Move Out',
    createMindMapTask:'Create Mind Map Task',
    taskSuffix:'Task',
    template:'Template',
    refreshClipCode: "Refresh Clip Code",
    clipCodeStillValid: "Clip code already exists and has not expired, cannot update",
    checkClipCodeError: "Error occurred while checking clip code",
    clipCodeRefreshSuccess: "Clip code refreshed successfully",
    clipCodeRefreshError: "Failed to refresh clip code",
    clipCodeAutoUpdated: "Clip code has been automatically updated due to inactivity, please note!",
  },
  currentUser: "Current User",
  privateInfo: "The current file owner has disabled sharing, viewing is not allowed",
  refreshHint: "Idle for more than 10 minutes, the system has been disconnected, please refresh the page",
  beforeDispoeHint: "Detected idle for more than 10 minutes, please click on the screen, otherwise it will be disconnected in 1 minute",
  inputEditKey:'Enter the edit password',
  sixBit:'6-bit character',
  closeMindCollect:'Collection has stopped',
  notAllowViewHint: "You are not allowed to view the submitted content. If you are an editor, please enter the editing code",
  allowEnterEditSuccess:'Edit password verification is successful, allowing entry to edit!',
  enterEditKeyWrong: "Edit password error. If you forget your password, please submit it again in the collection area, or request the password from the collection area administrator!",
  writeDownEditKey:'Please write down your edit code. You will need to enter the edit code next time you open it to edit:',
  reachMaxOpenFRUsage:'The current usage limit of shared documents has been reached, so new ones cannot be added. \n\t If you are the owner, please delete unnecessary documents and try adding new ones, or purchase an extended usage quota. If you do not have the right to delete, please ask the owner~',
  fluidRelayUsage:'Sharing Usage:',
  recentClick:'Recently Accessed',
  owner:'Owner:',
  linkShareSuccess:'Mind map link has been successfully sent',
  linkShareCooldown:'Please wait 1 minute before sending mind map link again',
  mindCollectLinkShareSuccess:'Mind map assignment task link has been successfully sent',
  mindCollectLinkShareCooldown:'Please wait 1 minute before sending mind map assignment task link again',
};
